import React from 'react';
import useDialog from '../../hooks/useDialog';
import BasicButton from '../Button/BasicButton';

const AlertDialog = ({ title, message, confirmText = 'Confirm', handleConfirm }) => {
  const { hideDialog } = useDialog();

  // dialog 바깥 영역(dim 포함) 클릭 시 꺼지지 않게(인터렉션 강제로 내용 인지하도록) 수정
  // 추후 필요 시 props 로 handleClose 내려 받아서 별도 함수 적용하거나 hideDialog() 끌 수 있도록 원복
  // const onClose = () => {
  //   if (handleClose) {
  //     handleClose();
  //   }
  //   hideDialog();
  // };

  const onConfirm = async () => {
    if (handleConfirm) {
      await handleConfirm();
    }
    hideDialog();
  };

  return (
    <div className={'modal-all-wrapper is-show type-dialog'}>
      <div className={'modal-dim-overlay'} />
      <div className='dialog-wrapper'>
        <div className='dialog-msg-group'>
          <h4 className={'dialog-title'}>{title}</h4>
          <p className={'dialog-msg'}>{message}</p>
        </div>
        <div className='dialog-button-group'>
          <BasicButton buttonTxt={confirmText} buttonType={'primary'} buttonSize={'sm'} onClick={onConfirm} />
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;
